import BaseService from './_base.service';

export const modalService = {
    page,
    edit,
    create,
    one,
    remove,
    search,
    removeLogic
};

function page(page,size, callback) {
    return BaseService.get("/modal/page/"+page+"/"+size, callback, true)
}

function search(page,size,filter, callback) {
    return BaseService.post("/modal/page/"+page+"/"+size,filter, callback, true)
}
function edit(id, bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.put("/modal/"+id, body, callback, true)
}

function create(bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.post("/modal/", body, callback, true)
}

function one(id,callback) {
    return BaseService.get("/modal/one/"+id, callback);
}

function remove(id,callback) {
    return BaseService.delete("/modal/"+id, callback);
}

function removeLogic(id,callback) {
    return BaseService.delete("/modal/"+id+"/logic", callback);
}
